import dayjs from 'dayjs';

export function getForamtDate(date) {
    var year = date.getFullYear();
    var month = ( 1 + date.getMonth())
    month = month >= 10 ? month : '0' + month;
    var day = date.getDate();
    day = day >= 10 ? day : '0' + day;
    return new Date(Number(year), Number(year), Number(day))
  }

  export function getDateToStringMonth(date) {
    var year = date.getFullYear();
    var month = ( 1 + date.getMonth())
    month = month >= 10 ? month : '0' + month;
    return year.toString()+month.toString()
  }

  export function getDateToStringDte(date) {
    var year = date.getFullYear();
    var month = ( 1 + date.getMonth())
    month = month >= 10 ? month : '0' + month;
    var day = date.getDate();
    day = day >= 10 ? day : '0' + day;
    return year.toString()+month.toString()+day.toString()
  }

  export function getStringToDate(str) {
    if (str === null || str === undefined || str === '') return null
    var y = str.substr(0, 4);
    var m = str.substr(4, 2);
    var d = str.substr(6, 2);
    return new Date(y,m-1,d);
    
  }

  //현재일자를 'format에 맞게 변형 YYYY-MM-DD'
  export function getCurrentDate(opt) {
    let now = new Date()

    if(opt) {
      if(opt.yyyy) {
        now = new Date(now.setFullYear(now.getFullYear() + opt.yyyy))
      }

      if(opt.mm) {
        now =new Date( now.setMonth(now.getMonth() + opt.mm))
      }

      if(opt.dd) {
        now = new Date(now.setDate(now.getDate() + opt.dd))
      }
    }

    return dayjs(now).format('YYYY-MM-DD')                     
  }

  //현재일자에서 이전달을 'format에 맞게 변형 YYYY-MM-DD' ex) a=1 한달전
  export function getPreMonth(month) {    
    return dayjs(new Date()).subtract(month, 'month').format('YYYY-MM-DD')    
  }

  //현재일자에서 이전일을 'format에 맞게 변형 YYYY-MM-DD' ex) a=1 1일전
  export function getPreDay(day) {    
    return dayjs(new Date()).subtract(day, 'day').format('YYYY-MM-DD')    
  }

  //특정일자를 'format에 맞게 변형 YYYY-MM-DD'
  export function getDateFormat(date) {
    if(date){
      return dayjs(date).format('YYYY-MM-DD')                     
    }else{
      return null
    }
  }

  //특정일자를 'format에 맞게 변형 YYYY-MM'
  export function getMonthFormat(date) {
    if(date){
      return dayjs(date).format('YYYY-MM')                     
    }else{
      return null
    }
  }

  //특정일자를 'format에 맞게 변형 YYYY'
  export function getYearFormat(date) {
    if(date){
      return dayjs(date).format('YYYY')                     
    }else{
      return null
    }
  }

  // 4자리 입력 숫자 시간 유효성 검사     맞으면 true 틀리면 false 
  export function timeCheck(inputTime) {
    let pattern = /^([1-9]|[01][0-9]|2[0-3])([0-5][0-9])$/
    let time = inputTime.replace(/[^0-9]/g,"")
    if(!pattern.test(time) || time.length !== 4) {
      return false
    } else {
      return true
    }   
  }

 /**
 * 좌, 우측문자열채우기
 *  - str : 원 문자열 
 *  - padLen : 최대 채우고자 하는 길이
 *  - padStr : 채우고자하는 문자(char)
 */
export function lpad(str, padLen, padStr) {
  if (padStr.length > padLen) {
    //채우고자 하는 문자열이 요청 길이보다 클때
    return str + "";
  }
  str += ""; // 문자로
  padStr += ""; // 문자로
  while (str.length < padLen)
      str = padStr + str;
  str = str.length >= padLen ? str.substring(0, padLen) : str;
  return str;
}
  
export function rpad(str, padLen, padStr) {
  if (padStr.length > padLen) {
    //채우고자 하는 문자열이 요청 길이보다 클때
    return str + "";
  }
  str += ""; // 문자로
  padStr += ""; // 문자로
  while (str.length < padLen)
      str += padStr;
  str = str.length >= padLen ? str.substring(0, padLen) : str;
  return str;
}

// 숫자 콤마찍기 EX) 3425 -> 3,425
// returnType(이상한 값이 들어갔을 때 반환 형태) -> 1: 값 그대로, 2: 0, 3: null, 나머지: undefined
export function getNumComma (val, returnType = 1) {
  let value = null
  let temp = val.toString().replace(/,/g, '').replace(/ /g, '')

  if (!isNaN(temp)) {
    const valArr = temp.split('.')
    value = (valArr[0] * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

    if(valArr.length > 1) {
      value = value + '.' + valArr[1]
    }
  } else {
    if (returnType === 1) {
      value = val
    } else if (returnType === 2) {
      value = 0
    } else if (returnType === 3) {
      value = null
    } else {
      value = undefined
    }
  }

  return value
}

export function toNum(val) {
  return !isNaN(val) ? Number(val) : 0
}

export function replaceNotNum() {
  return 'javascript: this.value = this.value.replace(/[.|a-z|A-Z|ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, \'\');'
}

export function getFirstDate(gbn = 'm') {
  let result
  let now = new Date()
  let yy = now.getFullYear()
  let mm = ('00' + (now.getMonth() + 1)).slice(-2)

  if(gbn === 'm') {
    result = `${yy}-${mm}-01`
  } else if(gbn === 'y') {
    result = `${yy}-01-01`
  }

  return result
}

export function getLastDate(gbn = 'm') {
  let result
  let now = new Date()
  let yy = now.getFullYear()
  let mm = ('00' + (now.getMonth() + 1)).slice(-2)
  let dd = new Date(yy, mm, 0).getDate()
  dd = ('00' + dd).slice(-2)

  if(gbn === 'm') {
    result = `${yy}-${mm}-${dd}`
  } else if(gbn === 'y') {
    result = `${yy}-12-31`
  }

  return result
}

export function getLastDate2(gbn = 'm', opt = { yyyy: 0, mm: 0}) {
  let result
  let now = new Date()
  if(opt) {
    if(opt.yyyy) {
      now = new Date(now.setFullYear(now.getFullYear() + opt.yyyy))
    }

    if(opt.mm) {
      now =new Date( now.setMonth(now.getMonth() + opt.mm))
    }
  }

  let yy = now.getFullYear()
  let mm = ('00' + (now.getMonth() + 1)).slice(-2)
  let dd = new Date(yy, mm, 0).getDate()
  dd = ('00' + dd).slice(-2)

  if(gbn === 'm') {
    result = `${yy}-${mm}-${dd}`
  } else if(gbn === 'y') {
    result = `${yy}-12-31`
  }

  return result
}

export function trim(str)
{
  return str.replace(/(\s+$)/g, "").replace(/(^\s*)/g, "").replace("\n", "").replace("\r", "");
}


